import React, {useEffect} from 'react';
import {useSelector} from '@utils';
import {useSendSolvedProblemMutation} from '@api';

import {AchievementType} from '@goproblems/shared/contracts/training';
export {AchievementType};

export default function SendTrainingAchievementRequest() {
    const [sendSolvedProblem] = useSendSolvedProblemMutation();
    const trainingSolvedCounter = useSelector(s => s.ui.trainingSolvedCounter);
    useEffect(() => {
        if (trainingSolvedCounter == 10) {
            sendSolvedProblem(AchievementType.TRAINING_SESSION);
        }
        if (trainingSolvedCounter == 100) {
            sendSolvedProblem(AchievementType.SERIOUS_GAINS);
        }
    }, [trainingSolvedCounter]);

    return <></>;
}
